import React from "react";

import SkilledInvisible1 from "../assets/img/skilledInvisible/skilledInvisible1.jpg";
import SkilledInvisible2 from "../assets/img/skilledInvisible/skilledInvisible2.jpg";
import EuropeanUnion from "../assets/img/skilledInvisible/europeanUnion.png";
import SplotNetwork from "../assets/img/skilledInvisible/splotNetwork.png";
import Partners from "../assets/img/skilledInvisible/partners.jpg";

const SkilledInvisibleContent = () => {
  return (
    <div className="skilled-invisible-container">
      <div className="skilled-invisible-section">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">Zdolni, niewidzialni</h2>
          <p className="about--text">
            W polskich szkołach każdego dnia uczą się dzieci i młodzież o
            wyjątkowym potencjale. Są ciekawe świata, zadają pytania, tworzą,
            analizują, eksperymentują i marzą o zmienianiu rzeczywistości. Wielu
            z nich osiąga bardzo dobre wyniki w nauce, zdobywa sukcesy w
            konkursach i olimpiadach. Z pozoru wydaje się, że nie potrzebują
            pomocy.
          </p>
          <p className="about--text">
            A jednak właśnie oni bardzo często pozostają niewidzialni.
          </p>
          <p className="about--text">
            Za wysokimi ocenami często kryją się samotność, przeciążenie, presja
            nieustannego bycia najlepszym, brak zrozumienia oraz poczucie, że
            ich potrzeby emocjonalne nie są równie ważne jak ich osiągnięcia.
          </p>
          <p className="about--text">
            Kampania społeczna <b>„Zdolni, niewidzialni”</b> powstała po to, aby
            to zmienić.
          </p>
          <p className="about--text">
            Nie chcemy mówić wyłącznie o talentach. Chcemy mówić przede
            wszystkim o człowieku, który za tym talentem stoi.
          </p>
        </div>
        <div className="skilled-invisible-image">
          <img src={SkilledInvisible1} alt="Dziecko" />
        </div>
      </div>

      <div className="skilled-invisible-section skilled-invisible-section--reversed">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">O projekcie</h2>

          <p className="about--text">
            <b>„Zdolni, niewidzialni”</b> to ogólnopolska kampania społeczna i
            edukacyjna. Projekt powstał jako odpowiedź na problem, który od lat
            obserwujemy podczas pracy z uczniami szczególnie uzdolnionymi.
          </p>
          <p className="about--text">
            Od kilkunastu lat wspieramy młodych ludzi o wysokim potencjale
            intelektualnym, prowadząc obozy naukowe, warsztaty, projekty
            edukacyjne oraz działania rzecznicze. W tym czasie poznaliśmy setki
            historii uczniów, którzy mimo ogromnych możliwości nie otrzymywali
            wsparcia odpowiadającego ich potrzebom.
          </p>
          <p className="about--text">
            Dlatego postanowiliśmy rozpocząć społeczną rozmowę o tym, że
            uczniowie zdolni również potrzebują zrozumienia, bezpieczeństwa,
            akceptacji i mądrego wsparcia.
          </p>
          <p className="about--text">
            Kampania łączy działania społeczne, edukacyjne i badawcze. W jej
            ramach prowadzimy diagnozę potrzeb uczniów szczególnie uzdolnionych,
            nauczycieli i rodziców, przygotowujemy raport oraz bezpłatne
            materiały edukacyjne, realizujemy kampanię medialną i tworzymy
            przestrzeń do rozmowy o tym, jak budować szkołę, w której talent nie
            będzie pozostawał niewidoczny.
          </p>
        </div>
        <div className="skilled-invisible-image">
          <img src={SkilledInvisible2} alt="Dziecko" />
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">
            Dlaczego powstała kampania?
          </h2>

          <p className="about--text">
            Przez wiele lat w edukacji skupialiśmy się przede wszystkim na
            uczniach, którzy mają trudności w nauce. To niezwykle ważne i
            potrzebne działania.
          </p>
          <p className="about--text">
            Jednocześnie niemal niezauważona pozostała druga grupa – uczniowie
            szczególnie uzdolnieni.
          </p>
          <p className="about--text">
            Wciąż funkcjonuje przekonanie, że „zdolny poradzi sobie sam”.
            Tymczasem rzeczywistość wygląda zupełnie inaczej.
          </p>
          <p className="about--text">
            Wielu uczniów zdolnych doświadcza ogromnej presji, perfekcjonizmu,
            lęku przed porażką i poczucia odpowiedzialności za spełnianie
            oczekiwań dorosłych. Często słyszą, że powinni radzić sobie lepiej
            niż inni. Ich sukcesy stają się normą, a trudności pozostają
            niezauważone.
          </p>
          <p className="about--text">
            Równocześnie polska szkoła mierzy się z coraz większym kryzysem
            edukacji STEM. Brakuje nauczycieli matematyki, fizyki, chemii i
            informatyki, a coraz mniej młodych ludzi wybiera kierunki techniczne
            i inżynieryjne. Nie możemy pozwolić sobie na marnowanie potencjału
            tych, którzy w przyszłości mogą tworzyć innowacje, rozwijać naukę i
            odpowiadać na największe wyzwania współczesnego świata.
          </p>
          <p className="about--text">
            Wierzymy, że zmiana zaczyna się od dostrzeżenia problemu.
          </p>
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">Spot</h2>

          <iframe
            title="movie"
            className="skilled-invisible-video"
            src="https://www.youtube.com/embed/niFS-QohWB0"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen></iframe>
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">Nasza motywacja</h2>

          <div className="skilled-invisible-boxes">
            <div className="skilled-invisible-box skilled-invisible-box--first">
              <h3 className="skilled-invisible-box-header">
                Nasza motywacja nie wynika z teorii. Wynika z rozmów z uczniami.
              </h3>
              <p>
                Z historii młodych ludzi, którzy mówili nam, że bardziej bali
                się zawieść nauczyciela niż popełnić błąd. Z opowieści rodziców,
                którzy nie wiedzieli, jak wspierać swoje dzieci. Z doświadczeń
                nauczycieli, którzy chcieli pomagać, ale nie otrzymali narzędzi
                ani przygotowania do pracy z uczniem szczególnie uzdolnionym.
              </p>
            </div>
            <div className="skilled-invisible-box skilled-invisible-box--second">
              <h3 className="skilled-invisible-box-header">
                Wiemy również, że szkoła może wyglądać inaczej.
              </h3>

              <p>
                Może być miejscem, w którym uczeń zdolny nie musi wybierać
                między sukcesem a dobrostanem. Miejscem, w którym rozwój talentu
                idzie w parze z poczuciem bezpieczeństwa, relacjami i zdrowiem
                psychicznym.
              </p>
            </div>
            <div className="skilled-invisible-box skilled-invisible-box--third">
              <h3 className="skilled-invisible-box-header">
                Dlatego zdecydowaliśmy się rozpocząć tę kampanię.
              </h3>

              <p>
                Bo wierzymy, że każde dziecko ma prawo rozwijać swój potencjał
                bez lęku i samotności.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">Cele projektu</h2>

          <p className="about--text">
            Kampania <b>„Zdolni, niewidzialni”</b> ma jeden wspólny cel –
            sprawić, aby uczniowie szczególnie uzdolnieni przestali być
            niewidzialni dla systemu edukacji. Realizujemy go poprzez:
          </p>

          <div className="skilled-invisible-grid">
            <div className="skilled-invisible-grid-box">
              <p>
                <b>zwiększanie świadomości społecznej</b> na temat potrzeb
                uczniów szczególnie uzdolnionych
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>prowadzenie badań i diagnoz</b>, które pokażą rzeczywistą
                sytuację uczniów zdolnych w polskich szkołach
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>wspieranie nauczycieli i rodziców</b> poprzez rzetelne
                materiały edukacyjne oraz praktyczne wskazówki
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>przeciwdziałanie stereotypom</b>, według których zdolny uczeń
                nie potrzebuje pomocy szczególnie w obszarze zdrowia
                psychicznego
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>promowanie szkoły opartej na równości szans</b>, w której
                rozwój potencjału każdego dziecka jest równie ważny
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>budowanie społecznej debaty</b> wokół problemu marginalizacji
                uczniów szczególnie uzdolnionych
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>
                <b>tworzenie trwałej sieci współpracy</b> między szkołami,
                samorządami, środowiskiem naukowym, rodzicami i organizacjami
                społecznymi
              </p>
            </div>
            <div className="skilled-invisible-grid-box">
              <p>Naszym celem nie jest wyłącznie zwrócenie uwagi na problem.</p>
              <p>
                <b>Naszym celem jest rozpoczęcie zmiany.</b>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">
            Szkoły biorące udział w badaniach
          </h2>

          <p className="about--text">
            Wierzymy, że aby skutecznie wspierać uczniów szczególnie
            uzdolnionych, najpierw trzeba ich naprawdę zrozumieć. Dlatego w
            ramach kampanii społecznej <b>„Zdolni, niewidzialni”</b> prowadzimy
            badania diagnostyczne wśród uczniów, rodziców i nauczycieli. Ich
            celem jest poznanie potrzeb młodych ludzi o wysokim potencjale
            intelektualnym, twórczym i poznawczym oraz zidentyfikowanie barier,
            z jakimi spotykają się w szkole. Dziękujemy wszystkim szkołom, które
            już włączyły się w to ważne przedsięwzięcie i wspólnie z nami budują
            bardziej uważną, empatyczną i wspierającą edukację.
          </p>
        </div>
      </div>

      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">
            Twoja szkoła również może do nas dołączyć
          </h2>

          <p className="about--text">
            Badania prowadzimy do <b>30 września 2026 roku</b>. Jeśli Państwa
            szkoła chce współtworzyć szeroki obraz sytuacji uczniów szczególnie
            uzdolnionych oraz mieć realny wpływ na tworzenie rekomendacji dla
            szkół, nauczycieli i rodziców, serdecznie zapraszamy do udziału.
            Każda szkoła to kolejny ważny głos, który pomoże lepiej zrozumieć
            potrzeby uczniów i sprawić, że żadne dziecko o wyjątkowym potencjale
            nie pozostanie niewidzialne.
          </p>
          <p className="about--text">Kontakt w sprawie udziału w badaniach:</p>
          <p className="about--text">
            Natalia Zarańska | tel. 601 069 863 | e-mail: kontakt@osadawiedzy.pl
          </p>
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full">
        <div className="skilled-invisible-column">
          <h2 className="skilled-invisible-header">Lista szkół</h2>

          <ol className="skilled-invisible-list">
            <li>X Liceum Ogólnokształcące w Gdyni</li>
            <li>I Liceum Ogólnokształcące w Lęborku</li>
            <li>Szkoła Podstawowa nr 1 w Bolszewie</li>
            <li>Szkoła Podstawowa w Pogórzu</li>
            <li>Szkoła Podstawowa w Żarnowcu</li>
            <li>Elementary International School of Gdansk</li>
            <li>Gdańska Autonomiczna Szkoła Podstawowa</li>
            <li>Sopocka Autonomiczna Szkoła Podstawowa</li>
            <li>Gdańskie Liceum Autonomiczne</li>
            <li>Sopockie Liceum Autonomiczne</li>
            <li>VI Liceum Ogólnokształcące w Gdyni</li>
            <li>Zespół Szkolno-Przedszkolny nr 3 w Gdyni</li>
            <li>Zespół Szkolno-Przedszkolny nr 1 w Redzie</li>
            <li>Szkoła Podstawowa w Łebczu</li>
            <li>Szkoła Podstawowa nr 3 w Lęborku</li>
            <li>Szkoła Podstawowa nr 9 w Słupsku</li>
          </ol>
        </div>
      </div>
      <div className="skilled-invisible-section skilled-invisible-section--full skilled-invisible-section--pair">
        <div className="skilled-invisible-column">
          <p className="about--text">
            Projekt realizowany jest w ramach grantu „Splot Wartości 2.0”
            współfinansowanego ze środków Programu Komisji Europejskiej CERV
            „Obywatele, równość, prawa i wartości” na lata 2021–2027.
          </p>

          <div className="skilled-invisible-pair skilled-invisible-pair--logos">
            <img src={EuropeanUnion} alt="Unia Europejska" />
            <img src={SplotNetwork} alt="Sieć splot" />
          </div>
        </div>
      </div>

      <img
        src={Partners}
        alt="Partnerzy"
        className="skilled-invisible-img"
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default SkilledInvisibleContent;
